import { render } from "./MsisdnPricesSettings.vue?vue&type=template&id=4cc2fa06"
import script from "./MsisdnPricesSettings.vue?vue&type=script&lang=js"
export * from "./MsisdnPricesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__